import axiosMailUpdate from '../services/axiosApi';
const saveToAPI = {
	async saveStep1(dataForPost, idRequest) {
		const response = await axiosMailUpdate.post(
			'api/v1/requestsrows/' + idRequest + '/dataclients',
			dataForPost
		);
		this.response = response.data.data;
		return this.response;
	},
	async savePut(dataForPut, idRequest) {
		let idDataModified =
		sessionStorage.getItem('idDataClients') !== null
				? '/' + sessionStorage.getItem('idDataClients')
				: '';
		const response = await axiosMailUpdate.put(
			'api/v1/requestsrows/' +
				idRequest +
				'/dataclients' +
				idDataModified,
			dataForPut
		);
		this.response = response.data.data;
		return this.response;
	},
	async saveNoUpdate(dataForNoUpdate, idRequest) {
		const response = await axiosMailUpdate.put(
			'api/v1/requestsrows/' + idRequest + '/reasonsnotpost',
			dataForNoUpdate
		);
		this.response = response.data.data;
		return this.response;
	},
	async putRejectRequest(dataForReject, idRequest) {
		const response = await axiosMailUpdate.put(
			'api/v1/requestsrows/' + idRequest + '/reject',
			dataForReject
		);
		this.response = response.data.data;
		return this.response;
	},
};
export default saveToAPI;
